import { render, staticRenderFns } from "./AdPayFreightBillMethod.vue?vue&type=template&id=852aef6c"
import script from "./AdPayFreightBillMethod.vue?vue&type=script&lang=js"
export * from "./AdPayFreightBillMethod.vue?vue&type=script&lang=js"
import style0 from "./AdPayFreightBillMethod.vue?vue&type=style&index=0&id=852aef6c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('852aef6c')) {
      api.createRecord('852aef6c', component.options)
    } else {
      api.reload('852aef6c', component.options)
    }
    module.hot.accept("./AdPayFreightBillMethod.vue?vue&type=template&id=852aef6c", function () {
      api.rerender('852aef6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AdPayFreightBillMethod.vue"
export default component.exports